import React, { Component } from 'react'
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import DoneOutlined from '@mui/icons-material/DoneOutlined';

class SmallProgressIndicator extends Component {
  constructor(props) {
    super(props);

    this.state = {
      
    }
  }

  componentDidMount() {
    if(this.props.progress === 100) {
      this.setState({isCompleted: true})
    } else {
      this.setState({isCompleted: false})
    }
  }

  componentWillReceiveProps(newProps) {
    if(newProps.progress === 100) {
      this.setState({isCompleted: true})
    } else {
      this.setState({isCompleted: false})
    }
  }

  render() {
    const {
      progress,
    } = this.props;
    const {
      isCompleted,
    } = this.state;

    return (
      <Box component="span" sx={styles.root}>
        <CircularProgress
          variant="determinate"
          value={100}
          sx={styles.progressBg}
          size={16}
        />
        <CircularProgress
          variant="determinate"
          value={progress}
          sx={[styles.progress, progress > 50 ? styles.green : styles.red]}
          size={16}
        />
        {isCompleted ?
          (<Box component="span" sx={styles.completedSign}>
            <DoneOutlined />
          </Box>) : null
        }
      </Box>
    )
  }
}

const styles = {
  root: {
    position: 'relative',
  },
  progressBg: {
    position: 'absolute',
    top: '9px',
    left: '12px',
    opacity: .25,
    color: 'currentColor',
  },
  progress: {
    position: 'absolute',
    top: '9px',
    left: '12px',
    color: 'seagreen',
  },
  completedSign: {
    position: 'absolute',
    top: '12px',
    left: '15px',
    color: 'seagreen',
    display: 'flex',
    '& svg': {
      fontSize: 10
    }
  },
  red: {
    color: 'orangered !important'
  },
  green: {
    color: 'seagreen !important'
  }
};

export default SmallProgressIndicator;